module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/varese.7d7b7969dd3d2f60a134fdcb0fa90043.jpg";